import {axiosGet, axiosPost} from "@/app/Helpers/AxiosHelper";
import {
    BODY_STYLE_UPDATE, COMPANY_INVOICE_SATUS,
    FORM_BUILDER_RESPONSE_POST,
    FORM_INPUT_COMMENT_DELETE, FORM_INPUT_COMMENT_LIST,
    FORM_INPUT_COMMENT_STORE,
    FORM_INPUT_COMMENT_UPDATE, GUEST_FORM_SUBMIT,
    LOCK_FORM_BUILDER_RESPONSE_POST,
    SHARE_RESPONSE_VIEW,
    TASK_ASSIGN_FORM_SHOW, TASK_AUDIT
} from "@/app/Config/ApiUrl";


export function getSectionView(eachFormIndex) {
    const applicable = this.forms[eachFormIndex].showSection;
    return applicable !== undefined ? applicable : true;
}

function updateClonedNode(node)
{
    // Update input elements
    const inputs = node.getElementsByTagName('input');
    inputs.forEach(input => {
        if (input.closest('.pdf-item')) {
            const componentValue = input.closest('.pdf-item').getAttribute('componentvalue');
            if ((componentValue !== null) && componentValue !== undefined) {
                if(input.type === 'radio' || input.type === 'checkbox'){
                    if(input.value === componentValue){
                        input.checked = true;
                    }
                }else{
                    input.setAttribute("value", componentValue);
                }
            }
        }
    });

    // Update textarea elements
    const textareas = node.getElementsByTagName('textarea');
    textareas.forEach(textarea => {
        if (textarea.closest('.pdf-item')) {
            const componentValue = textarea.closest('.pdf-item').getAttribute('componentvalue');
            if ((componentValue !== null) && componentValue !== undefined) {
                textarea.innerHTML = componentValue;
            }
        }
    });

    // Update select elements
    const selects = node.getElementsByTagName('select');
    selects.forEach(select => {
        if (select.closest('.pdf-item')) {
            const componentValue = select.closest('.pdf-item').getAttribute('componentvalue');
            if ((componentValue !== null) && componentValue !== undefined) {
                // select.value = componentValue;
                select.setAttribute("value", componentValue);
                const myOption = select.querySelector('option[value="'+componentValue+'"'); // Find the option with specific value

                if (myOption) {
                    myOption.setAttribute('selected', 'selected'); // Set the selected attribute
                }
            }
        }
    });
    return node;
}

export async function generateReport() {
    // await this.$forceUpdate();
    this.actionPreloader = true;
    this.showSectionSwitch = false;

    // Select all input and textarea elements
    const elements = document.querySelectorAll('input, textarea');

    // Add the print-placeholder class to all elements and hide placeholders
    elements.forEach(element => {
        element.dataset.placeholder = element.placeholder; // Save the current placeholder
        element.placeholder = ''; // Hide the placeholder
    });

    // Emit events to set content length and indicate print in progress
    this.$hub.$emit('setParagraphContentLength', { maxCharacters: Infinity });
    this.$hub.$emit('printInProgress', { status: true });

    // Set the form color
    this.setFormColor();

    // Hide elements not needed for printing
    this.hideOnPrint = true;

    // Wait for Vue to apply the changes
    await this.$nextTick();

    // Retrieve the content to print
    let printSectionClone = this.$refs.pdfSection.cloneNode(true);
    let printContents = updateClonedNode(printSectionClone);

    // Create an iframe for printing
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';

    const iframeDoc = iframe.contentWindow.document;

    // Write the content and styles to the iframe document
    iframeDoc.open();
    iframeDoc.write(`
      <html>
        <head>
          <title>Print Preview</title>
          ${this.getStyles()}
           <style>
           @media print {
            .is---active {
                background: none !important; /* Remove background during print */
              }
            body {
              -webkit-print-color-adjust: exact;
                margin: 0 !important;
            }
              @page {
                margin: 15mm 9mm 15mm 9mm ; /* Add space for the header with top margin of 40mm */
              }
           }
            </style>
        </head>
        <body>
          ${printContents.innerHTML}
        </body>
      </html>
    `);
    iframeDoc.close();

    // Wait for stylesheets to load before printing
    await this.waitForStylesheets(iframe.contentWindow);

    // Print the content
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Cleanup
    document.body.removeChild(iframe);
    this.showSectionSwitch = true;

    // Reset the preloader and print status
    this.actionPreloader = false;
    this.$hub.$emit('printInProgress', { status: false });

    // Restore placeholders
    elements.forEach(element => {
        element.placeholder = element.dataset.placeholder; // Restore the placeholder
        delete element.dataset.placeholder; // Clean up the dataset attribute
    });
}



export function getStyles() {
    const baseUrl = window.location.origin;

    // Explicitly add the required theme CSS links
    return `

       <link media="all" type="text/css" rel="stylesheet" href="${baseUrl}/css/core.css">
       <link media="all" type="text/css" rel="stylesheet" href="${baseUrl}/css/app.css">

        ${this.getAllDocumentStyles()}
      `;
}

export function getAllDocumentStyles() {
    let styles = '';
    for (let i = 0; i < document.styleSheets.length; i++) {
        const styleSheet = document.styleSheets[i];
        try {
            if (styleSheet.cssRules) {
                for (let j = 0; j < styleSheet.cssRules.length; j++) {
                    styles += styleSheet.cssRules[j].cssText;
                }
            }
        } catch (e) {
            if (styleSheet.href) {
                styles += `<link rel="stylesheet" type="text/css" href="${styleSheet.href}" />`;
            }
        }
    }
    return `<style>${styles}</style>`;
}

export function showFormActions(param, status) {

    var showAction = this.$store.state.sharedData.sharedData?.showFormActions;
    if (showAction != null) {
        if (param === 'assigneAccess') {
            return showAction.assigneAccess;
        } else if (param === 'auditorAccess') {
            return showAction.auditorAccess;
        } else if (param === 'ownerAccess') {
            return showAction.ownerAccess;
        }
    } else {
        return status === 'save_response';
    }
}

// Function to check height and add page breaks
// checkAndAddPageBreak() {
//   // Get the content wrapper element
//   const contentWrapper = this.$el.querySelector('.wrapper--forms');
//
//   // Get the inner elements within the content wrapper
//   const innerElements = contentWrapper.children;
//
//   // Initialize the height counter and page break count
//   let totalHeight = 0;
//   let pageBreakCount = 0;
//   // Flag to check if it's the first page
//   let isFirstPage = true;
//
//   // Loop through each inner element and calculate the total height
//   for (let i = 0; i < innerElements.length; i++) {
//     // if (isFirstPage) {
//     //   totalHeight += 120; // Adjust this function to get the actual header height
//     //   isFirstPage = false;
//     // }
//     totalHeight += innerElements[i].offsetHeight;
//
//     // Check if the height has reached a multiple of 1000px
//     if (totalHeight >= (pageBreakCount + 1) * 740) {
//      // Insert a div with class "html2pdf__page-break" after the current inner element
//       const pageBreakDiv = document.createElement('div');
//       pageBreakDiv.className = 'html2pdf__page-break mt-3';
//       innerElements[i].insertAdjacentElement('afterend', pageBreakDiv);
//       pageBreakCount++;
//     }
//   }
// },

export function checkAndAddPageBreak() {
    // Get the main container element
    const mainContainer = this.$el.querySelector('.el-form.formElements');

    // Initialize variables
    let totalHeight = 0;
    let pageBreakCount = 0;
    let remainingSpace = 0;

    // Height threshold for page break
    const pageBreakThreshold = 900; // Adjust as needed

    // Iterate through each element within the main container
    const elements = mainContainer.querySelectorAll('*');
    elements.forEach((element, index) => {
        // Calculate the height of the element
        const elementHeight = element.getBoundingClientRect().height;

        // Update the total height
        totalHeight += elementHeight;

        // Calculate the remaining space on the current page
        remainingSpace = pageBreakThreshold - (totalHeight % pageBreakThreshold);

        // Check if adding a page break is necessary
        if (remainingSpace < elementHeight) {
            // Insert a div with class "html2pdf__page-break" after the current element
            const pageBreakDiv = document.createElement('div');
            pageBreakDiv.className = 'html2pdf__page-break';

            // Insert footer for the current page
            const currentPageFooter = document.createElement('div');
            currentPageFooter.className = 'page-footer';
            element.insertAdjacentElement('afterend', currentPageFooter);

            // Insert header for the next page after the page break div
            const nextPageHeader = document.createElement('div');
            nextPageHeader.className = 'page-header';
            pageBreakDiv.insertAdjacentElement('afterend', nextPageHeader);

            // Insert the page break div after the current element
            element.insertAdjacentElement('afterend', pageBreakDiv);

            pageBreakCount++;
            totalHeight = 0; // Reset the total height for the next page
        }
    });

    // Check if the last page is empty and remove the page break
    const lastPageElements = mainContainer.querySelectorAll('.html2pdf__page-break:last-of-type');
    if (lastPageElements.length > 0) {
        const lastPage = lastPageElements[0].nextElementSibling;
        if (!lastPage) {
            lastPageElements[0].remove();
        }
    }
}


export function backToList() {
    this.back();
}

export function changeColor(num) {

    this.on_select = true;
    this.select_color = this.color_data.filter(data => {
        return data.theme_no === num;
    });
    this.root.style.setProperty(
        "--form-color",
        this.select_color[0].form_color
    );
    this.root.style.setProperty(
        "--form-header-color",
        this.select_color[0].form_header_color
    );
    this.root.style.setProperty(
        "--form-header-text-color",
        this.select_color[0].form_header_text_color
    );
    // this.root.style.setProperty(
    //   "--form-border-color",
    //   this.select_color[0].form_border_color
    // );
    this.root.style.setProperty(
        "--font-color",
        this.select_color[0].font_color
    );
    //
}

// async beforeDownload ({ html2pdf, options, pdfContent }) {
//
//   html2pdf().set({
//     pageBreak: { mode: 'avoid-all', before: '#page2el' }
//   });
//   await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
//     const totalPages = pdf.internal.getNumberOfPages()
//     for (let i = 1; i <= totalPages; i++) {
//       pdf.setPage(i)
//       pdf.setFontSize(10)
//       pdf.setTextColor(150)
//       pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
//     }
//   }).save()
// },


export async function startPagination($event) {
    console.info($event)
    this.$toastr.s("Printing task initiated in the background, Please wait...");
}

export async function onPdfComplete() {
    this.$toastr.s("Printing task finished.");
    this.$hub.$emit('setParagraphContentLength', {
        maxCharacters: 200,
    });
    this.$hub.$emit('printInProgress', {
        status: false,
    });
    //this.setDefaultColor()
}

export async function waitForStylesheets(contentWindow) {
    return new Promise((resolve) => {
        const links = contentWindow.document.querySelectorAll('link[rel="stylesheet"]');
        if (links.length === 0) {
            resolve();
        }

        let loaded = 0;
        links.forEach(link => {
            link.onload = () => {
                loaded += 1;
                if (loaded === links.length) {
                    resolve();
                }
            };
        });

        // Fallback in case `onload` doesn't fire for some links
        setTimeout(resolve, 3000);
    });
}

export function addPageBreaks(content) {
    const pageBreakThreshold = 900; // Adjust as needed
    const elements = Array.from(content.querySelectorAll('*'));
    let totalHeight = 0;
    let pageBreakCount = 0;

    elements.forEach(element => {
        const elementHeight = element.getBoundingClientRect().height;
        totalHeight += elementHeight;

        if (totalHeight >= (pageBreakCount + 1) * pageBreakThreshold) {
            const pageBreakDiv = document.createElement('div');
            pageBreakDiv.className = 'html2pdf__page-break';
            element.insertAdjacentElement('afterend', pageBreakDiv);
            pageBreakCount++;
            totalHeight = 0;
        }
    });
}


export function generatePdf() {
    const mainContainer = this.$el.querySelector('.el-form.formElements');
    const pageBreakThreshold = 900; // Adjust as needed
    const elements = Array.from(mainContainer.querySelectorAll('*'));
    const totalPages = Math.ceil(elements.reduce((acc, el) => acc + el.getBoundingClientRect().height, 0) / pageBreakThreshold);

    const pdf = this.$refs.html2Pdf;

    for (let page = 0; page < totalPages; page++) {
        const currentPageElements = elements.filter((el, index) => {
            const accumulatedHeight = elements.slice(0, index).reduce((acc, el) => acc + el.getBoundingClientRect().height, 0);
            const currentHeight = el.getBoundingClientRect().height;
            return accumulatedHeight >= page * pageBreakThreshold && accumulatedHeight < (page + 1) * pageBreakThreshold - currentHeight;
        });

        const currentPageHtml = currentPageElements.reduce((acc, el) => acc + el.outerHTML, '');
        const pageWrapper = document.createElement('div');
        pageWrapper.innerHTML = currentPageHtml;

        // You might need to process pageWrapper here to adjust styles or remove unnecessary elements

        const pageHtml = pageWrapper.innerHTML;
        pdf.html(pageHtml);
        if (page < totalPages - 1) {
            pdf.addPage();
        }
    }

    pdf.save();
}

export function beforeDownload({html2pdf, options, pdfContent}) {

    this.addPageBreaks(pdfContent);
    html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        // Function to add page break divs
        // const addPageBreaks = (content) => {
        //   const pageBreakThreshold = 900; // Adjust as needed
        //   const elements = Array.from(content.querySelectorAll('*'));
        //   let totalHeight = 0;
        //   let pageBreakCount = 0;
        //
        //   elements.forEach(element => {
        //     const elementHeight = element.getBoundingClientRect().height;
        //     totalHeight += elementHeight;
        //
        //     if (totalHeight >= (pageBreakCount + 1) * pageBreakThreshold) {
        //       const pageBreakDiv = document.createElement('div');
        //       pageBreakDiv.className = 'html2pdf__page-break';
        //       element.insertAdjacentElement('afterend', pageBreakDiv);
        //       pageBreakCount++;
        //       totalHeight = 0;
        //     }
        //   });
        // };

        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3));

            // Adding header
            // pdf.setFontSize(12);
            // pdf.setTextColor(0);
            // pdf.text('Header for Page ' + i, 10, 10);

            // Adding footer
            // pdf.setFontSize(10);
            // pdf.setTextColor(150);
            // pdf.text('Footer for Page ' + i, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3));

            // If it's not the last page, add a page break
            if (i < totalPages) {
                pdf.addPage();
            }
        }

        // Call addPageBreaks to insert page break divs
        // addPageBreaks(pdfContent);
    }).save();
}


export function onProgress($event) {
    console.info($event)
}

export function hasPaginated($event) {
    console.info($event)
}

export function previous() {
    if (this.formType && this.formType === 'import_body_styling') {
        this.$store.commit('deleteSharedData', "showFormActions");
        this.back();
    } else {
        this.$emit(" ", 1);
    }
}

export function saveStyling() {

    // console.log(this.companyInfoCheck);
    // if(this.on_select == true){
    let bodyStyling = JSON.stringify(this.select_color);
    let headerContent = JSON.stringify(this.companyInfoCheck)
    if (this.formType && this.formType === 'import_body_styling') {
        this.$emit('styling', bodyStyling, headerContent);
    } else {
        axiosPost(BODY_STYLE_UPDATE, {
            bodyStyling: bodyStyling,
            headerContent: headerContent,
            form_body_id: this.id
        }).then(res => {
            this.$toastr.s(res.data.message);
            this.backList();
            this.select_color = [];
        }).catch(res => {
            console.error(res)
        });
        // }else{
        //     this.$toastr.s("Form save without styling");
        //     this.backList();
        // }

    }
}

export function removeFileAction(fileid) {
    this.remove_id = fileid;
    this.deleteConfirmationModalActive = true;
    // this.$store.state.uploadFilePath.dataUploadFilePath.splice(fileid , 1);
}

export function canceled() {
    this.remove_id = "";
    this.deleteConfirmationModalActive = false;
}

export function confirmed() {
    this.$store.state.uploadFilePath.dataUploadFilePath.splice(
        this.remove_id,
        1
    );

    this.hideDeleteModal();
}

export function hideDeleteModal() {
    this.deleteLoader = false;
    $("#task-delete").modal("hide");
    this.canceled();
}

export function getData() {// let form_id = this.getQueryParam();
    /**
     * * Pass the value to server, so that we can get required form response,
     * */

    let url;
    if (this.is_shareResponse === true) {
        url = `${SHARE_RESPONSE_VIEW}/${this.$props.data.link}`;
    } else {
        if (typeof this.taskId == "undefined") {
            if (this.response === "save_response" || this.response == 'save-response-view') {
                url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&form_revision_id=${this.$props.form_revision_id}&type=${this.$props.response}&user_id=${this.$props.data?.user_id ?? this.$props.userId}&batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
            } else {
                url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&task_id=${this.$props.taskId ?? ''}&form_revision_id=${this.$props.form_revision_id ?? ''}&type=${this.$props.response}&user_id=${this.$store.state.sharedData?.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;

                // url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?type=view`;
            }
        } else if (typeof this.userId != "undefined") {
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?task_id=${this.$props.taskId ?? this.$attrs.taskId ?? this.$props.data?.task_id}&form_id=${this.$props.form_id}&form_revision_id=${this.form_revision_id}&user_id=${this.$props.data?.user_id ?? this.$store.state.sharedData.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
        } else {
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?task_id=${this.taskId}&form_id=${this.form_id}&form_revision_id=${this.form_revision_id}`;
        }
    }
    this.$store.commit('updateSharedData', {index: "formPreviewUrl", newValue: url})
    axiosGet(url)
        .then(res => {

            if (res.data.length !== 0) {
                // this.forms = res.data.body;
                this.forms = res.data.body.map(form => ({

                    ...form,
                    showSection: form.hasOwnProperty('showSection') ? form.showSection : true
                }));

                this.form_body_id = res.data.id;
                // this.form_id = res.data.form_id;
                this.user_id = res.data.user_id;
                this.companyInfo = res.data.companyInfo;
                this.view_type = res.data.view_type;
                this.formInfo = res.data.form_revision;
                this.created_by = res.data.form_revision.created_by;
                this.companyInfoCheck = JSON.parse(res.data.header_content);
                this.formStatus = res.data.status;
                this.responseStatus = res.data.response_status;

                let data = JSON.parse(res.data.bodyStyle);
                this.savedFormBodyStyle = data

                // this.changeColor(data[0].theme_no);
                if (data && data.length > 0) {
                    this.root.style.setProperty("--form-color", data[0].form_color);
                    this.root.style.setProperty("--font-color", data[0].font_color);
                    this.root.style.setProperty("--form-header-color", data[0].form_header_color ?? '#fff');
                    this.root.style.setProperty("--form-header-text-color", data[0].form_header_text_color ?? '#000000');

                } else {
                    this.root.style.setProperty("--form-color", "#fff");
                    // this.root.style.setProperty("--form-border-color", "#898989");
                    this.root.style.setProperty("--font-color", "#000");
                }

                // if (res.data.status == 2) {
                //   this.status = res.data.status;
                // }

                this.getInputsComments();
            }
        })
        .catch(res => {
            this.$toastr.e(res.response.data.message);
            this.$toastr.e('Closing in 3 sec...');
            setTimeout(function () {
                window.close();
            }, 3000);
        });
}

export function saveForm(status, isGuest = false) {
    this.actionPreloader = true;
    // if(this.status)
    // {
    //   this.status = 2;
    // }
    // this.$attrs['currentField'].uploadURL = this.$store.state.uploadFilePath.dataUploadFilePath ;
    let formData = [];
    for (let formObj of this.forms) {
        let fieldCount = 0;
        for (let obj of formObj.fields) {
            if (
                obj.fieldType === "TextInput" ||
                obj.fieldType === "LongTextInput" ||
                obj.fieldType === "NumberInput" ||
                obj.fieldType === "SelectList" ||
                obj.fieldType === "RadioButton" ||
                obj.fieldType === "Checkbox" ||
                obj.fieldType === "TimePicker" ||
                obj.fieldType === "DatePicker" ||
                obj.fieldType === "DatetimePicker" ||
                obj.fieldType === "Rating" ||
                obj.fieldType === "Upload" ||
                obj.fieldType === "UploadMediaFile" ||
                obj.fieldType === "Instruction" ||
                obj.fieldType === "TableComponent" ||
                obj.fieldType === "SignaturePad" ||
                obj.fieldType === "Name" ||
                obj.fieldType === "Address" ||
                obj.fieldType === "Email" ||
                obj.fieldType === "Phone" ||
                obj.fieldType === "elswitch"
            ) {
                formData.push({
                    index: obj.componentId,
                    value: obj.componentValue,
                    form_id: this.form_id,
                    form_revision_id: this.form_revision_id,
                    meta: obj,
                    type: obj.fieldType,
                    task_id: this.taskId ?? 0,
                    is_lock_response: obj.is_lock_response ?? null,
                });
            }
            fieldCount++;
        }
    }
    //  console.log('FORM RESPONSE', formData);
    let url = this.isLock === 'no' ? FORM_BUILDER_RESPONSE_POST : LOCK_FORM_BUILDER_RESPONSE_POST;
    let postData = {
        data: formData,
        id: this.form_body_id,
        task_id: this.taskId ?? 0,
        form_revision_id: this.form_revision_id,
        form_status: status,
        type: this.type,
        batch: this.$store.state.sharedData.sharedData?.guestFormData?.batch,
        saveStrategy: this.isUpdateStrategy,
        isOurSaveRsponse: this.$props.response == 'save_response' && !this.taskId ? true : false,
    }
    if(isGuest){
        url = GUEST_FORM_SUBMIT;
        const urlParams = new URLSearchParams(window.location.search);
        const guestEmail = urlParams.get('email');
        postData = {
            data: formData,
            saveStrategy: this.isUpdateStrategy,
            guest_user_id: this.$store.state.sharedData.sharedData.guestUserData.id??localStorage.getItem('guestUserId'),
            guest_user_email: guestEmail??'',
            id: this.form_body_id,
            task_id: this.taskId ?? 0,
            form_revision_id: this.form_revision_id,
            form_status: status,
            type: this.type
        }
    }

    axiosPost(url, postData)
        .then(res => {
            this.$toastr.s(res.data.message);
            this.actionPreloader = false;
            if (this.isNewTab === 'yes' || this.isLock === 'yes') {
                setTimeout(function () {
                    window.close();
                }, 2000);
            } else {
                this.back();
            }
            // console.info(res);
        })
        .catch(res => {
            console.error(res);
            this.actionPreloader = false;
        });
}

export function getQueryParam() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    return params.get("form_id");
}

// deleteElement(index, form) {
//   FormBuilder.deleteElement(index, form);
// },
export function cloneElementField(index, field, form, event) {

    this.field_id = field.componentId;
    const user = this.userRole.full_name;
    const val = [{user: user}];
    this.commentObject[this.field_id]
        ? this.commentObject[this.field_id].push({user: user})
        : this.$set(this.commentObject, this.field_id, val);

    let commentElement = document.getElementById('comment-container-' + field.componentId)
    commentElement.classList.toggle('active-field-comment')
}

export function editElementProperties(fields) {

    this.commentText = fields.componentId;
    this.componentFieldId = fields.componentId;

    var element = this.$refs[fields.componentId];

    if (element) {
        if (element.classList.contains("is---active")) {
            element
                .getElementsByClassName("is---active")[0]
                .scrollIntoView({behavior: "smooth", block: "end"});
        }
    }
}

export function focusInput(i) {
    // alert(i);

    this.componentFieldId = i;
}

export function enter(textComment, i) {
    this.commentRequest.comment = textComment[i];
    this.commentRequest.component_id = this.componentFieldId;
    this.commentRequest.form_body_id = this.form_body_id;
    this.commentRequest.text_id = this.textCommentId;
    this.commentRequest.task_id = this.taskId;

    if (this.textCommentId !== 0) {

        axiosPost(FORM_INPUT_COMMENT_UPDATE, this.commentRequest)
            .then(res => {
                this.$toastr.s(res.data.message);
            })
            .catch(res => {
                this.$toastr.e(res.data.error);
            })
            .finally(() => {
                this.$set(this.textComment, i, "");
                this.textCommentId = 0;
                this.getInputsComments();
            });
    } else {

        textComment[i]
            ? axiosPost(FORM_INPUT_COMMENT_STORE, this.commentRequest)
                .then(res => {
                    this.$toastr.s(res.data.message);
                })
                .catch(res => {
                    this.$toastr.e(res.data.error);
                })
                .finally(() => {
                    this.$set(this.textComment, i, "");
                    this.getInputsComments();
                })
            : this.$toastr.e("Please fill comment box ");
    }
}

export function editComment(commentIndex, i, comm) {
    this.$set(this.textComment, i, comm.text);
    this.textCommentId = comm.text_id;


    if (this.textComment !== null) {
        this.reloadFun(i);
        this.focusInput(i);
    }
}

export function deleteComment(commentIndex, i, id) {
    axiosGet(FORM_INPUT_COMMENT_DELETE + "/" + id)
        .then(res => {
            this.$toastr.s(res.data.message);
        })
        .catch(res => {
            console.error(res);
        })
        .finally(() => {
            this.getInputsComments();
        });
}

export function reloadFun(i) {
    //
    return this.textComment[i];
}

export function setDefaultColor() {
    this.root.style.setProperty("--form-color", this.savedFormBodyStyle[0].form_color);
    this.root.style.setProperty("--font-color", this.savedFormBodyStyle[0].font_color);
    this.root.style.setProperty("--form-header-color", this.savedFormBodyStyle[0].form_header_color ?? '#fff');
    this.root.style.setProperty("--form-header-text-color", this.savedFormBodyStyle[0].form_header_text_color ?? '#000000');
}

export function setFormColor() {
    this.root.style.setProperty("--form-color", '#ffffff');
    this.root.style.setProperty("--form-header-color", '#ffffff');
    this.root.style.setProperty("--form-header-text-color", '#00000');
    this.root.style.setProperty("--font-color", '#00000');
}

export function getInputsComments() {
    axiosGet(
        FORM_INPUT_COMMENT_LIST +
        "/" +
        this.form_body_id +
        "?task_id=" +
        this.taskId
    )
        .then(res => {
            if (res.data.length !== 0) {
                this.commentObject = res.data;
            }
        })
        .catch(res => {
            console.error(res);
        });
}

export function invoiceStatus() {
    let id = this.userRole.company_id;
    axiosGet(COMPANY_INVOICE_SATUS + "/" + id)
        .then(res => {
            this.invoice_Status = res.data;
        })
        .catch(res => {
            console.error(res);
        });
}

export function taskAudit(status) {

    this.actionPreloader = true;

    let data = {
        status: status,
        form_revision_id: this.form_revision_id,
        task_id: this.taskId,
        user_id: this.user_id,
    };

    // let form_revision_id = this.form_revision_id;
    // let task_id = this.taskId;
    let url = TASK_AUDIT;
    axiosPost(url, data)
        .then(response => {
            this.$toastr.s(response.data.message);
            this.actionPreloader = false;
        })
        .catch(res => {
            console.error(res);
            this.actionPreloader = false;
        });
}
